import React from 'react';
import './SessionRenewModal.css';

export default function SessionRenewModal({ onContinue, onLogout }) {
  return (
    <div className="modal-overlay">
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="renew-title">
        <h3 id="renew-title">Continue session?</h3>
        <p>Your session will expire soon. Would you like to continue?</p>
        <div className="actions">
          <button onClick={onLogout} className="btn-secondary">Logout</button>
          <button onClick={onContinue} className="btn-primary">Continue</button>
        </div>
      </div>
    </div>
  );
}
